var exports = {
  "L": "overlay__UQ_3cY",
  "k": "stickySkeletonWrapper__axKf7q",
};

module.exports = exports;
